import * as React from "react";
import { CircleCheck, Coffee } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const carouselImages = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/dolce_gusto_compatible_capsules_display.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/tassimo_compatible_pods_assortment.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/premium_coffee_capsules_crema.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/espresso_lungo_cappuccino_capsules.png"];
const flavors = [{
  name: "Espresso",
  description: "Intense et riche en arômes pour un réveil parfait."
}, {
  name: "Lungo",
  description: "Doux et équilibré, idéal pour prolonger le plaisir."
}, {
  name: "Cappuccino",
  description: "Onctueux et gourmand avec une mousse de lait généreuse."
}];
export default function CapsulesCompatiblesDolceGustoTassimo() {
  return <section id="capsules-compatibles-dolce-gusto-tassimo" className="relative bg-background py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-[0.02] overflow-hidden">
        <Coffee className="w-[120vw] h-[120vw] max-w-[1200px] max-h-[1200px] -rotate-12 text-foreground" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          
          {}
          <div className="lg:col-span-7 w-full">
            <div className="relative">
              {}
              <div className="absolute -inset-4 bg-secondary/50 rounded-[2.5rem] -z-10 blur-2xl opacity-50"></div>
              
              <Carousel opts={{
              loop: true,
              align: "center"
            }} className="w-full">
                <CarouselContent>
                  {carouselImages.map((img, index) => <CarouselItem key={index} data-index={index}>
                      <div className="p-2 sm:p-4">
                        <div className="overflow-hidden rounded-3xl shadow-2xl shadow-shadow-color/20 bg-card border border-border/50 aspect-[4/3] relative group">
                          <img src={img} alt={`Capsules compatibles vue ${index + 1}`} className="h-full object-cover transition-transform duration-700 group-hover:scale-105 !w-[1000px]" />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                      </div>
                    </CarouselItem>)}
                </CarouselContent>
                <div className="hidden sm:block">
                  <CarouselPrevious className="left-8 bg-background/80 backdrop-blur-sm border-none shadow-md hover:bg-background text-foreground" />
                  <CarouselNext className="right-8 bg-background/80 backdrop-blur-sm border-none shadow-md hover:bg-background text-foreground" />
                </div>
              </Carousel>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="bg-primary text-primary-foreground rounded-[2.5rem] p-8 sm:p-10 lg:p-12 shadow-2xl shadow-primary/20 relative overflow-hidden">
              {}
              <div className="absolute top-0 right-0 w-64 h-64 bg-ring/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none"></div>
              
              <div className="relative z-10">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-foreground/10 border border-primary-foreground/20 text-sm font-medium mb-6">
                  <Coffee className="size-4 text-ring" />
                  <span>KBC Coffee Service</span>
                </div>
                
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold mb-6 leading-tight">
                  Compatibilité <span className="text-ring">Parfaite</span>
                </h2>
                
                <div className="text-primary-foreground/80 text-lg mb-10 leading-relaxed">
                  <p>Capsules compatibles avec machines Dolce Gusto et Tassimo.</p>
                  <p>Idéal pour bureaux et particuliers.</p>
                </div>

                <ul className="space-y-6 mb-12">
                  {flavors.map((flavor, index) => <li key={index} data-index={index} className="flex items-start gap-4">
                      <div className="mt-1 bg-ring/20 p-1.5 rounded-full shrink-0">
                        <CircleCheck className="size-5 text-ring" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-lg text-primary-foreground">{flavor.name}</h3>
                        <p className="text-primary-foreground/70 text-sm mt-1">{flavor.description}</p>
                      </div>
                    </li>)}
                </ul>

                <Button asChild size="lg" className="w-full sm:w-auto bg-ring text-primary hover:bg-ring/90 text-base h-14 px-8 rounded-xl shadow-lg shadow-ring/20 transition-all hover:-translate-y-1">
                  <Link to="/CapsulesPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 w-full bg-ring text-primary text-base h-14 px-8 rounded-xl shadow-lg shadow-ring/20 transition-all !text-justify disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 sm:w-auto hover:bg-ring/90 hover:-translate-y-1">Découvrir nos capsules</Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}